/**
 * Gets video by preference with seeded random selection
 */
export const getVideoByPreference = (videos, preferenceId, seedId = null) => {
  if (!preferenceId || !Array.isArray(videos) || videos.length === 0) {
    return null;
  }

  const matchingVideos = videos.filter((video) => {
    if (!video || !Array.isArray(video.preferences)) return false;
    return video.preferences.some((pref) => pref?.id === preferenceId);
  });

  if (matchingVideos.length === 0) return null;

  const index =
    seedId !== null && !isNaN(seedId)
      ? Math.abs(Number(seedId)) % matchingVideos.length
      : Math.floor(Math.random() * matchingVideos.length);

  return matchingVideos[index] || null;
};

/**
 * Gets random video for physio users with seeded selection
 * No preference filtering - uses all available videos
 */
export const getRandomVideoForPhysio = (videos, seedId = null) => {
  if (!Array.isArray(videos) || videos.length === 0) {
    return null;
  }

  const index =
    seedId !== null && !isNaN(seedId)
      ? Math.abs(Number(seedId)) % videos.length
      : Math.floor(Math.random() * videos.length);

  return videos[index] || null;
};

/**
 * Gets all videos matching a preference
 */
export const getVideosByPreference = (videos, preferenceId) => {
  if (!preferenceId || !Array.isArray(videos) || videos.length === 0) {
    return [];
  }

  return videos.filter((video) => {
    if (!video || !Array.isArray(video.preferences)) return false;
    return video.preferences.some((pref) => pref?.id === preferenceId);
  });
};

/**
 * Gets video by external ID
 */
export const getVideoByExternalId = (videos, externalId) => {
  if (!externalId || !Array.isArray(videos) || videos.length === 0) {
    return null;
  }

  return videos.find((video) => video?.externalId === externalId) || null;
};

/**
 * Gets random video matching preference name
 */
export const getRandomVideoByPreferenceName = (videos, preferenceName) => {
  if (!preferenceName || !Array.isArray(videos) || videos.length === 0) {
    return null;
  }

  const matchingVideos = videos.filter((video) => {
    if (!video || !Array.isArray(video.preferences)) return false;
    return video.preferences.some(
      (pref) => pref?.name?.toLowerCase() === preferenceName.toLowerCase()
    );
  });

  if (matchingVideos.length === 0) {
    const nonRandomVideos = videos.filter((video) => {
      if (!video || !Array.isArray(video.preferences)) return false;
      return !video.preferences.some((pref) => pref?.name === "Random");
    });

    const fallbackVideos =
      nonRandomVideos.length > 0 ? nonRandomVideos : videos;
    return (
      fallbackVideos[Math.floor(Math.random() * fallbackVideos.length)] || null
    );
  }

  return (
    matchingVideos[Math.floor(Math.random() * matchingVideos.length)] || null
  );
};
